export default "__VITE_ASSET__BvfGSK____"